// file: paymentCard.jsx
import React, { useState } from "react";
import styles from "./paymentCard.module.scss";
import DoneIcon from "@mui/icons-material/Done";
import JsonView from "react18-json-view";
import { Card, CardContent, Typography } from "@mui/material";

const PaymentCard = ({ paymentDetails, calculation }) => {
  console.log("paymentDetails", paymentDetails);
  console.log("cartBundleId", calculation);
  const [isOpen, setIsOpen] = useState(false);

  const getDateTime = (timestamp) => {
    const date = new Date(timestamp * 1000);

    const formatted = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    console.log(formatted); // 07/12/25 09:10 (example in IST)

    // console.log(date.toString());
    return formatted;
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Success Icon */}
        <div className={styles.iconWrapper}>
          <DoneIcon />
        </div>

        {/* Title */}
        <h2 className={styles.title}>Payment captured successfully</h2>

        {/* Info Rows */}
        <div className={styles.row}>
          <span className={styles.label}>Card Bundle ID</span>
          <span className={styles.value}>{calculation?.cartBundleId}</span>
        </div>

        <hr className={styles.divider} />

        <div className={styles.row}>
          <span className={styles.label}>Payment Method</span>
          <span className={styles.value} style={{textTransform:"uppercase"}}>{paymentDetails?.method}</span>
        </div>

        {/* <hr className={styles.divider} />

        <div className={styles.row}>
          <span className={styles.label}>UPI Transaction ID</span>
          <span className={styles.value}>UPI2024010223456</span>
        </div> */}

        <hr className={styles.divider} />

        <div className={styles.row}>
          <span className={styles.label}>Date & Time</span>
          <span className={styles.value}>
            {getDateTime(paymentDetails?.created_at)}
          </span>
        </div>

        <hr className={styles.divider} />

        <div className={styles.row}>
          <span className={styles.label}>Razor Charges</span>
          <span className={styles.value}>₹ {paymentDetails?.fee / 100}</span>
        </div>

        <div className={styles.row} style={{ flexDirection: "column" }}>
          <div className={styles.label} onClick={() => setIsOpen(!isOpen)}>
            Transaction Info
          </div>

          <div className={styles.row} style={{ flexDirection: "column" }}>
            {paymentDetails.acquirer_data
              ? Object.entries(paymentDetails.acquirer_data).map(
                  ([key, value]) => (
                    <div
                      className={styles.row}
                      key={key}
                      style={{ display: "flex" }}
                    >
                      <div className={styles.label} style={{ width: "30%" }}>
                        {key}
                      </div>
                      <div
                        className={styles.value}
                        style={{
                          wordBreak: "break-all",
                          width: "50%",
                          textAlign: "right",
                        }}
                      >
                        {value}
                      </div>
                    </div>
                  )
                )
              : "-"}
          </div>
        </div>

        {/* Total Amount Box */}
        <div className={styles.totalBox}>
          <span className={styles.totalLabel}>Total Amt</span>
          <span className={styles.totalValue}>
            ₹ {paymentDetails?.amount / 100}
          </span>
        </div>

        {/* <JsonView
          data={paymentDetails}
          collapsed={false}
          enableClipboard={false}
        /> */}
      </div>
    </div>
  );
};

export default PaymentCard;
